import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/teatro';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-69" data-mp="e3didugelir3">
      <div className="mx-auto max-w-6xl" data-id="element-70" data-mp="9mhfagqn76z">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-71" data-mp="58z5fyjcikb5">
          <div className="lg:col-span-7" data-id="element-72" data-mp="574jcgwc8m5h">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-73" data-mp="3mguiw1ojetxq">La differenza con TEATRO PRONTO™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-74" data-mp="3rhi7kgpamyos">
              Dalla recita improvvisata a <em className="text-red-700" data-id="element-75" data-mp="3diqv0yq2xl2r">uno spettacolo già pronto.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-76" data-mp="3ihlpixxesy2p">
            Immagina di arrivare a novembre con la recita di Natale già scelta. Sai cosa provare ogni
            settimana – e hai già il copione, i ruoli, i giochi, la scenografia e le griglie di valutazione.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-77" data-mp="1fa3ljmvmun8e">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-78" data-mp="1szxa043875hl" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-79" data-mp="10c1gf88ydtp1">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-80" data-mp="wapoux6iqye7">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-81" data-mp="1aaqz338obi6c">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-82" data-mp="1a84heas2jmae">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-83" data-mp="15dqtetfqkhfr">Prima di TEATRO PRONTO™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-84" data-mp="2lrqonr3mziwo">
              Ti riconosci?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-85" data-mp="2orsb6w580vpd">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-86" data-mp="2srsuau39lv2r">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-87" data-mp="2xsgn9lb20lzm" />
                  <span data-id="element-88" data-mp="32qi4e0ox6b8g">
                    <span className="block font-semibold text-slate-900/80" data-id="element-89" data-mp="32oxj71ohw4n9">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-90" data-mp="2a001p0s3ybvk">
            <p className="text-sm font-semibold text-red-300" data-id="element-91" data-mp="2jrw3omxbem52">Con TEATRO PRONTO™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-92" data-mp="2jtz5s5bqs5q5">
              Prepari meno. Vai in scena sereno.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-93" data-mp="1ratizdrbdk9r">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-94" data-mp="1jr12kyup4hlg">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-95" data-mp="1etshape93xfz">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="19w93fqlgtmok" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-97" data-mp="10vauqv030qzn">
          Concentrati sui tuoi alunni in scena – non sullo scrivere tutto da solo.
        </p>
      </div>
    </section>;
}